<template>
  <div class="page-container">
    <div class="page-title-container">
      <h1 class="page-title">Procesar Libro Diario</h1>
    </div>
    <div class="containerl">
      <div class="row justify-content-center">
        <div class="col-12 col-md-8">
          <b-card tag="article" no-body class="custom-card custom-card--sm">
            <b-card-header
              header-tag="section"
              class="
                custom-card-header
                d-flex
                justify-content-between
                align-items-center
              "
            >
              <h3>Seleccione fecha</h3>
            </b-card-header>

            <b-card-body class="custom-card-body">
              <form class="custom-form" @submit.prevent="save">
                <div class="form-group">
                  <label for="input-date">Fecha de inicio</label>
                  <b-input-group>
                    <FormDatepicker
                      label-id="selected-start-date"
                      :show-calendar="showStartDatePicker"
                      :min="$store.getters['app/getStartDate']"
                      :hideHeader="true"
                      :error="$v.selectedStartDate.$error"
                      @show="showStartDatePicker = true"
                      @hidden="showStartDatePicker = false"
                      v-model="selectedStartDate"
                      class="w-100"
                    />
                  </b-input-group>
                  <span
                    class="error"
                    v-if="$v.selectedStartDate.$error && !$v.selectedStartDate.required"
                    >Fecha de inicio es requerida</span
                  >
                </div>
                <div class="form-group">
                  <label for="input-date">Fecha de fin</label>
                  <b-input-group>
                    <FormDatepicker
                      label-id="selected-end-date"
                      :show-calendar="showEndDatePicker"
                      :min="$store.getters['app/getStartDate']"
                      :hideHeader="true"
                      :error="$v.selectedEndDate.$error"
                      @show="showEndDatePicker = true"
                      @hidden="showEndDatePicker = false"
                      v-model="selectedEndDate"
                      class="w-100"
                    />
                  </b-input-group>
                  <span
                    class="error"
                    v-if="$v.selectedEndDate.$error && !$v.selectedEndDate.required"
                    >Fecha de fin es requerida</span
                  >
                </div>
                <div class="form-group-buttons text-right w-100">
                  <router-link
                    :to="{ name: 'daily-process-list' }"
                    class="button button-cancel mr-2"
                  >
                    Cancelar
                  </router-link>
                  <button class="button button-primary" type="submit">
                    Procesar
                  </button>
                </div>
              </form>
            </b-card-body>
          </b-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ProcessService } from "@/core/services";
import { Alert } from "@/core/utils";
import { required } from "vuelidate/lib/validators";
import { FormDatepicker } from "@/core/components";

export default {
  data() {
    return {
      selectedStartDate: this.$store.getters["app/getAvailableDate"],
      selectedEndDate: this.$store.getters["app/getAvailableDate"],
      showStartDatePicker: false,
      showEndDatePicker: false,
    };
  },
  components: {
    FormDatepicker,
  },
  validations: {
    selectedStartDate: { required },
    selectedEndDate: { required },
  },
  methods: {
    async save() {
      const self = this;
      self.$v.$touch();
      if (self.$v.$error) return;
      await this.$store.dispatch("app/loading", true);
      const params = {startDate: this.selectedStartDate, endDate: this.selectedEndDate };
      try {
        const payload = (await ProcessService.startProcessRange(params)).payload;
        if (!payload.success && payload.messages) {
          this.errors = payload.messages;
          return;
        }
        await this.$store.dispatch("app/loadAvailableDate");
        Alert.success("Ha iniciado el procesamiento del libro exitosamente");
        this.$router.push({ name: "daily-process-list" });
      } catch (ex) {
        console.error(ex);
        Alert.error(ex.errors.message);
      } finally {
        await this.$store.dispatch("app/loading", false);
      }
    },
  },
  async created() {
    await this.$store.dispatch("app/loadAvailableDate");
  },
};
</script>

<style lang="stylus" scoped></style>
